module.exports = __webpack_public_path__ + "img/cubits_blue_256.e681fd0d.png";